import _s from 'underscore.string'
import isString from 'strings/isString'

export default (value) =>
  isString(value) &&
  _s.startsWith(value, '/') &&
  (_s.endsWith(value, '/') || _s.endsWith(value, '/i'))
